import { Fill } from 'nano-slots';
import { cn } from 'Utils/cn';
import PropTypes from 'prop-types';

export default function DrawerStackFooter({ children, className }) {
    return (
        <Fill name="drawer-stack-footer">
            <div className={cn('sticky bottom-0 bg-white pt-2 pb-4 z-10 flex gap-2 px-4 md:px-6', className)}>
                {children}
            </div>
        </Fill>
    );
}

DrawerStackFooter.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};
